<template>
    <div class="input-wrapper" :class="[compact && 'compact', fill && 'fill']">
        <label class="base-label">{{label}}</label>
        <input class="base-input"
            v-bind="{
                ...$attrs,
                onInput: (event)=>$emit('update:modelValue', event.target.value)
             }"
            :value="modelValue"
            :placeholder="placeholder"
            @focus="()=>{$emit('focus')}"
            @blur="()=>{$emit('blur')}"
        />
        <img class="icon icon-search" :class="{'visible': !clearable}" src="@/assets/SearchButton.svg">
        <img class="icon icon-clear" :class="{'visible': clearable}" src="@/assets/CancelBasic.svg" @click="clear">
    </div>
</template>

<script>
    export default {
        name: "FilterInput",
        props: {
            modelValue: { type: [String, Number], default: '' },
            label: { type: String, default: null },
            placeholder: { type: String, default: '' },
            emptyImage: { type: String, default: '' },
            compact: Boolean,
            fill: Boolean
        },
        emits: ['update:modelValue', 'focus', 'blur'],
        computed: {
          clearable () { return !!this.modelValue },
        },
        methods: {
          clear () {
            this.$emit('update:modelValue','')
          }
        }
    }
</script>

<style scoped>
.input-wrapper {
    position: relative;
}
.input-wrapper input {
    border-width: 2px;
    height: 48px;
}
.icon {
    width: 22px;
    height: 22px;
    position: absolute;
    top: 40px;
    right: 18px;
    transition: opacity 0.2s;
    opacity: 0;
}
.icon-search {
    pointer-events: none;
}
.icon.visible { opacity: 100; }
.icon.icon-clear {
    cursor:  normal;
}
.icon.icon-clear.visible {
    cursor: pointer;
}


.input-wrapper.compact .base-label {
    display: none;
}
.input-wrapper.compact {
    height: 48px;
}
.input-wrapper.compact .base-input {
    margin-top: 0;
}
.input-wrapper.compact .icon {
    top: 50%;
    right: 18px;
    transform: translateY(-50%);
}

.input-wrapper.fill {
    flex:  1;
}
</style>
